import { render, staticRenderFns } from "./SubdistributorsTab.vue?vue&type=template&id=6f1f0dd5"
import script from "./SubdistributorsTab.vue?vue&type=script&lang=js"
export * from "./SubdistributorsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports